<app-modal id="add-card-form" [maskClose]="false">

  <aside class="modal">
    <div class="modal-body" id="update-card-form-body">
      <div class="header">
        <div class="title-text" >Add Card</div>
        <div class="button regular close" (click)="cancel()"><span
        class="icon">&#x00D7;</span></div>
      </div>
      <form   [ngClass]="{'hidden': cardSelected}" [formGroup]="form" (submit)="save($event)">
        <div class="form-row"  >
          <label for="card-element">Credit Card </label>
          <div id="new-card-element"></div>
          @if (askForPrimary) {
            <div class="checkbox">
              <input type="checkbox" id="agreeTerms" (change)="makePrimary($event)">Make Primary
            </div>
          }
          <div id="card-element-errors" role="alert" ></div>
          <div class="buttons">
            <button type="button" (click)="updateCard()" class="button regular solid-green" [disabled]="btnClicked">Submit</button>
          </div>
        </div>
      </form>
    </div>
    @if (loading) {
      <div class="loader"><div></div><div></div><div></div><div></div></div>
    }
  </aside>
  <div class="modal-background"></div>
</app-modal>
<app-success-modal [modalId]="'success-addCard-modal'"  (confirmChoice)="close()" [text]="successText" [maskClose]="true"></app-success-modal>
<!-- <app-error-modal [modalId]="'error-AddCard'" [text]="errorText"></app-error-modal> -->
<app-new-error-modal modalId="add-card-error" [options]="errorOptions"></app-new-error-modal>
